import AdebifyLtvCohortReducer from './reducers';

export default AdebifyLtvCohortReducer;
